import * as React from 'react';

import { Box, Typography } from '@mui/material';

import LoadingButton from '../../Button/LoadingButton';
import BaseDialog, { BaseDialogProps } from '../Base';

const ManageInAppDialog: React.FC<BaseDialogProps> = ({ onClose, ...restProps }) => {
  const handleClose = React.useCallback(() => {
    onClose?.({}, 'escapeKeyDown');
  }, [onClose]);

  return (
    <BaseDialog
      onClose={onClose}
      title='Subscription'
      width='480px'
      height='unset'
      sx={{ '.MuiDialogContent-root': { overflow: 'visible' } }}
      {...restProps}
    >
      <Box>
        <Typography textAlign='left' sx={{ paddingTop: '8px', paddingBottom: '40px' }}>
          Please make changes to your current plan through the Beautypass app, as you initially
          purchased it there
        </Typography>
        <LoadingButton
          fullWidth
          variant='contained'
          size='large'
          sx={{ paddingY: '12px' }}
          onClick={handleClose}
        >
          Close
        </LoadingButton>
      </Box>
    </BaseDialog>
  );
};

export default ManageInAppDialog;
